import React, { Component } from "react";

import { SnackbarProvider } from "notistack";
import AlertBanner from "./AlertBanner";

import PropTypes from "prop-types";
import LoaderOverlay from "./LoaderOverlayMask"
import { Login } from "./Login";

function GetAlertBanner(props) {
  if (props.alert?.showAlert) {
    return (<AlertBanner {...props} />)
  } else {
    return null;
  }
}
GetAlertBanner.propTypes = {
  alert: PropTypes.object
}
export default class LoginWidget extends Component {
  render() {
    return (
      <SnackbarProvider maxSnack={3} anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}>
        <div className="relative min-w-screen h-screen bg-primary-bg flex flex-col overflow-hidden">
          <LoaderOverlay
            styles={{
              overlay: (base) => ({
                ...base,
                background: "rgba(0, 0, 0, 0.1)"
              })
            }}
          >
            <GetAlertBanner alert={this.props.alert} />
            <Login
              defaultLocale={this.props.locale}
              baseUrl={this.props.baseUrl}
              logoUrl={this.props.logoUrl}
            />
          </LoaderOverlay>

        </div>
      </SnackbarProvider>
    )
  }
}

LoginWidget.propTypes = {
  locale: PropTypes.string,
  logoUrl: PropTypes.string,
  baseUrl: PropTypes.string,
  splashImage: PropTypes.string,
  alert: PropTypes.object
}
